import { applyTicketFilters, ticketFilterParams, readListFilters } from "../listFilters";
import { connect } from "react-redux";
import React from "react";
import "antd/dist/antd.css";
import { withRouter } from "react-router-dom";
// import "./index.css";
import {
  Button,
  Col,
  Row,
  Table,
  Radio,
  Spin,
  Tag,
  Tooltip,
  Input,
} from "antd";
import { Link } from "react-router-dom";
import PlusOutlined from "@ant-design/icons/lib/icons/PlusOutlined";
import { authAxios } from "../utils";
import { ListStatusURL, ticketsListURL } from "../constants";
import moment from "moment";
import { AdvancedSearchForm } from "./Component";
import Cookies from "universal-cookie";
import FilterOutlined from "@ant-design/icons/lib/icons/FilterOutlined";
import { cloneTicket, ticketData } from "../store/reducers/ticketData";
import { QuestionCircleOutlined, TagsOutlined } from "@ant-design/icons";
// import { useScreenSize } from "./Function";

const cookies = new Cookies();

// const tagsFilter = [
//   {
//     id: 0,
//     icon: <TagsOutlined />,
//     name: "Được gắn thẻ",
//     content: "Danh sách ticket mà nhân viên được tag tên trong phần phản hồi.",
//   },
// ];


const columns = [
      // {
      //     title: "STT",
      //     dataIndex: "index",
      //     key: "index",
      //     render: (value, item, index) => ((pagination.current || 1) - 1) * pagination.pageSize + index + 1,
      //     sorter: (a, b) => a.index - b.index,
      //     sortDirections: ['descend', 'ascend', 'descend'],
      // },

      {
        title: "Mã yêu cầu",
        dataIndex: "ticket_code",
        key: "ticket_code",
        sorter: (a) => a,
        filterKey: "ticket_code",
        render: (value, item, index) => (
          <a href={"/tickets/" + item.id}>{value}</a>
        ),
        type: "text",
        canSearch: true,
        fixed: "left",
        width: "7%",
        // width: 150,
      },
      {
        title: "Loại yêu cầu",
        dataIndex: "ticket_type_name",
        key: "ticket_type_name",
        sorter: (a) => a,
        filterKey: "ticket_type_name",
        width: "11%",
        type: "text",
        canSearch: true,
      },
      {
        title: "Tiêu đề",
        dataIndex: "title",
        key: "title",
        ellipsis: true,
        filterKey: "title",
        width: "20%",
        type: "text",
        canSearch: true,
        // sortDirections: ['ascend', 'descend', 'ascend'],
        // sorter: (a, b) => a.title - b.title,
      },
      {
        title: (
          <>
            Phòng/Department
            <Tooltip title="Phòng/Department">
              <QuestionCircleOutlined style={{ marginLeft: 5 }} />
            </Tooltip>
          </>
        ),
        dataIndex: "bophansudung_name",
        key: "bophansudung_name",
        filterKey: "bophansudung_name",
        width: "5%",
        type: "text",
      },
      {
        title: (
          <>
            Team
            <Tooltip title="Team sử dụng">
              <QuestionCircleOutlined style={{ marginLeft: 5 }} />
            </Tooltip>
          </>
        ),
        dataIndex: "list_name_team_use",
        key: "list_name_team_use",
        filterKey: "list_name_team_use",
        width: "5%",
        type: "text",
        render: (text, record) => record.list_name_team_use && record.list_name_team_use.map((item) => item.name).join(", "),
      },
      {
        title: "Văn phòng",
        dataIndex: "vanphong_name",
        key: "vanphong_name",
        filterKey: "vanphong_name",
        width: "7%",
        // filters: [
        //   { text: "DSP", value: "DSP" },
        //   { text: "Seatech", value: "Seatech" }
        // ],
        // filteredValue: filteredInfo.vanphong || null,
        // onFilter: (value, record) => record.vanphong.includes(value),
        sorter: (a) => a,
        type: "text",
        canSearch: true,
        // sortOrder: sortedInfo.columnKey === "vanphong" && sortedInfo.order
      },
      {
        title: "Ngày mong muốn",
        dataIndex: "duedate",
        key: "duedate",
        filterKey: "duedate",
        width: "7%",
        render: (text, record) => moment(text).format("L"),
        sorter: (a) => a,
        type: "date",
        canSearch: true,
      },
      {
        title: "Người phê duyệt",
        dataIndex: "approve_user_name",
        key: "approve_user_name",
        filterKey: "approve_user_name",
        width: "7%",
        sorter: (a) => a,
        type: "text",
        canSearch: true,
      },
      {
        title: "Trạng thái",
        dataIndex: "ticket_status_name",
        key: "ticket_status_name",
        filterKey: "ticket_status_name",
        width: "7%",
        type: "text",
        canSearch: false,
        // filters: [{ text: "Mới", value: "Mới" }, { text: "Đã duyệt", value: "Đã duyệt" },
        // { text: "Đang xử lý", value: "Đang xử lý" },{ text: "Hoàn thành", value: "Hoàn thành" }],
        // filteredValue: filteredInfo.trangthai || null,
        // onFilter: (value, record) => record.trangthai.includes(value),
        sorter: (a) => a,
        // sortOrder: sortedInfo.columnKey === "name" && sortedInfo.order,
        render: (text, record) => (
          <a
            style={{
              backgroundColor: record.color,
              color: "#ffffff",
              padding: "3px 5px 3px 5px",
            }}
          >
            {text}
          </a>
        ),
      },
      {
        title: "Cập nhật bởi",
        dataIndex: "updating_user_name",
        key: "updating_user_name",
        filterKey: "updating_user_name",
        width: "7%",
        type: "text",
        canSearch: true,
      },
    ]
const filter_search = columns.filter(item => item.canSearch)
const map_search = filter_search.map((item, index) => {return item.filterKey})

const  suffixSearch = (
    <Tooltip title="Tìm theo Mã Ticket, Tiêu đề, Ghi chú, Phòng/Department, Team sử dụng, Ngày tạo (DD/MM/YYYY)">
      <QuestionCircleOutlined style={{ marginLeft: 5 }} />
    </Tooltip>
  );
class Danhsachyeucau extends React.Component {
  state = {
    filteredInfo: null,
    sortedInfo: null,
    data: [],
    total_page: 0,
    pagination: { pageSize: 10, current: 1, page: 1 },
    lsStatus: [],
    searching: false,
    paramsSearch: {},
    // selectedTags: [],
    screenWidth: window.innerWidth,
    changeSearchAllValue: "",
    selectedStatus: "all",
  };

  handleResize = () => {
    this.setState({ screenWidth: window.innerWidth });
  };

  componentDidMount() {
    this.setState({ loading: true });
    this.fetchStatusListAPI();

    const savedFilter = sessionStorage.getItem("filterState_ListTicket");
    const json_filter = readListFilters("filterState_ListTicket");

    if (savedFilter && Object.keys(json_filter).length > 0) {
      // Lấy ra dict các key mà giá trị không trống
      const filter_searchCol = Object.fromEntries(
          Object.entries(json_filter).filter(([_, value]) => value !== "" && value !== null && value !== undefined)
      );
      // lọc các key có trong phần lọc của columns
      const hasMatchingKey = map_search.some(key => key in filter_searchCol);
      if (hasMatchingKey) {
        this.setState({
          searching: true,
        });
      }

      this.setState({
        paramsSearch: json_filter,
        changeSearchAllValue: json_filter.searchAll || "",
      });

      if (json_filter.hasOwnProperty("ticket_status_name")) {
        this.setState({
          selectedStatus: json_filter.ticket_status_name,
        });
      }
      // if (json_filter.hasOwnProperty("type_option")) {
      //   this.setState({
      //     selectedTags: json_filter.type_option,
      //   });
      // }
      this.fetchTicketListAPI({
        page_size: this.state.pagination.pageSize,
        page: 1,
        columnSort: "id",
        typeSort: "descend",
        ...json_filter,
      });
    } else {
      this.setState({
        searching: false,
      });
      this.fetchTicketListAPI({
        page_size: this.state.pagination.pageSize,
        page: 1,
        columnSort: "id",
        typeSort: "descend",
      });
    }

    window.addEventListener("resize", this.handleResize);
  }

  // Gỡ bỏ event listener khi component bị unmount để tránh memory leak.
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleChange = (pagination, filters, sorter, extra) => {
    this.setState({ loading: true });
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    pager.pageSize = pagination.pageSize;
    this.setState({
      pagination: pager,
      sortedInfo: sorter,
    });
    this.fetchTicketListAPI({
      page_size: pagination.pageSize,
      page: pagination.current,
      columnSort: sorter.field || "id",
      typeSort: sorter.order || "descend",
      ...filters,
      ...this.state.paramsSearch,
    });
  };

  fetchStatusListAPI = (params = {}) => {
    authAxios(cookies.get("token"))
      .get(ListStatusURL)
      .then((res) => {
        let lsTemp = [{ label: "Tất cả", value: "all" }];
        res.data.results.map((item, index) => {
          lsTemp.push({ label: `${item.name}`, value: `${item.name}` });
        });

        this.setState({ lsStatus: lsTemp });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        // if (err.response.status === 401) {
        //     this.props.history.push('/login');
        // }
      });
  };

  fetchTicketListAPI = (params = {}) => {
    params = ticketFilterParams(params, false);
    const requestId = this.ticketRequestId = (this.ticketRequestId || 0) + 1;
    this.setState({ loading: true });
    params.typeView = "create";
    authAxios(cookies.get("token"))
      .get(ticketsListURL, { params: params })
      .then((res) => {
        if (requestId !== this.ticketRequestId) return;
        this.setState({
          data: res.data.results,
          loading: false,
          total_page: res.data.count,
        });
      })
      .catch((err) => {
        if (requestId !== this.ticketRequestId) return;
        this.setState({ error: err, loading: false });
        if (err.response?.status === 401) {
          this.props.history.push("/login");
        }
      });
  };
  filterTicketList = (params = {}) => {
    applyTicketFilters(this, params, "filterState_ListTicket");
  };

  // SearchTicketList = (value, event) => {
  //     let {sortKey, sortDirection, pageSize} = this.state;
  //     const pager = {...this.state.pagination};
  //     pager.current = 1;
  //     pager.page = 1;
  //     this.setState({searchKey:value,pagination:pager})
  //     this.fetchTicketListAPI({
  //         page_size: this.state.pagination.pageSize,
  //         page: 1,
  //         columnSort: 'id',
  //         typeSort: 'descend',
  //         search: value,
  //     })
  // }

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };
  callBackFilter = (values) => {
    this.filterTicketList(values);
  };

  // handleChangeTags = (tag, checked) => {
  //   const nextSelectedTags = checked
  //     ? [...this.state.selectedTags, tag]
  //     : this.state.selectedTags.filter((t) => t !== tag);
  //   this.setState({ selectedTags: nextSelectedTags });

  //   // Khi click tag thì chỉ view DS theo tag và trạng thái ticket đã chọn
  //   // (ko view lọc, khi click tìm kiếm thì mới view theo cả tag và lọc)
  //   const pager = { ...this.state.pagination };
  //   pager.current = 1;
  //   pager.page = 1;
  //   const paramsSearch = {
  //     ...this.state.paramsSearch,
  //     type_option: nextSelectedTags,
  //   };
  //   this.setState({ pagination: pager, paramsSearch: paramsSearch });

  //   if (nextSelectedTags.length === 0) {
  //     // data trong filterState_ListTicket đã được cập nhật trước đó
  //     const getParamsSearch =
  //       JSON.parse(sessionStorage.getItem("filterState_ListTicket")) || {};
  //     delete getParamsSearch.type_option;
  //     sessionStorage.setItem(
  //       "filterState_ListTicket",
  //       JSON.stringify(getParamsSearch)
  //     );
  //   } else {
  //     sessionStorage.setItem(
  //       "filterState_ListTicket",
  //       JSON.stringify(paramsSearch)
  //     );
  //   }

  //   this.fetchTicketListAPI({
  //     page_size: this.state.pagination.pageSize,
  //     page: 1,
  //     columnSort: "id",
  //     typeSort: "descend",
  //     type_option: nextSelectedTags,
  //     ...paramsSearch,
  //     // ticket_status_name: paramsSearch.hasOwnProperty("ticket_status_name")
  //     //   ? paramsSearch.ticket_status_name
  //     //   : undefined,
  //   });
  // };

  onChangeSearchAll = (value) => {
    this.setState({ changeSearchAllValue: value });
    // Nếu xóa trống (Backspace) thì chạy onSearchAll với values là trống
    // Nếu nhập mà ko click search, sau đó xóa trống thì cũng ko dc tải lại search
    if (
      value.trim() === "" &&
      (this.state.paramsSearch.searchAll || "").trim() !== ""
    ) {
      this.onSearchAll("", true);
    }
  };

  onSearchAll = (values) => {
    this.setState({ changeSearchAllValue: values });
    this.filterTicketList({ searchAll: values });
  };

  render() {
    let {
      loading,
      data,
      total_page,
      pagination,
      selectedTags,
      screenWidth,
      changeSearchAllValue,
    } = this.state;
    let { userPermission } = this.props;

    const toggleSearchForm = () => {
      const searching = this.state.searching;
      this.setState({ searching: !searching });
    };
    const onFilterTrangThai = (e) => {
      let obj = {};
      if (e.target.value !== "all") {
        obj.ticket_status_name = e.target.value;
      } else {
        obj.ticket_status_name = undefined;
      }
      this.setState({ selectedStatus: e.target.value });

      this.filterTicketList(obj);
    };
    return (
      <>
        <Row justify="end">
          <Col sm={screenWidth > 1680 ? 6 : screenWidth > 1254 ? 7 : 8}>
            <Input.Search
              value={changeSearchAllValue}
              placeholder="Tìm kiếm nhanh"
              onChange={(e) => this.onChangeSearchAll(e.target.value)}
              onSearch={this.onSearchAll}
              enterButton
              allowClear
              suffix={suffixSearch}
              className="search-all-list-ticket"
            />
          </Col>

          <Col
            sm={screenWidth > 1680 ? 1.5 : 2}
            style={{ paddingLeft: "10px" }}
          >
            <Button
              onClick={toggleSearchForm}
              style={{ width: "100%" }}
              icon={<FilterOutlined />}
            >
              Lọc
            </Button>
          </Col>

          {userPermission && userPermission.includes("can_create") ? (
            <Col
              sm={screenWidth > 1680 ? 2 : screenWidth > 1254 ? 3 : 4}
              style={{ paddingLeft: "10px" }}
            >
              <Button
                type={"primary"}
                danger
                style={{ marginBottom: 15, width: "100%" }}
                onClick={() => {
                  this.props.cloneTicket(false);
                  this.props.ticketData({});
                }}
              >
                <Link to={"/create_ticket"}>
                  <PlusOutlined /> Tạo yêu cầu
                </Link>
              </Button>
            </Col>
          ) : null}
        </Row>

        <Row>
          <Col sm={24} style={{ float: "left" }}>
            <Radio.Group
              options={this.state.lsStatus}
              onChange={onFilterTrangThai}
              value={this.state.selectedStatus}
              defaultValue={"all"}
              optionType="button"
              buttonStyle="solid"
            />

            {/* <div className="tags-list-all">
              {tagsFilter.map((tag) => (
                <Tooltip placement="top" title={tag.content}>
                  <Tag.CheckableTag
                    key={tag.id}
                    checked={selectedTags.includes(tag.id)}
                    onChange={(checked) =>
                      this.handleChangeTags(tag.id, checked)
                    }
                    className="tags-list-ticket"
                  >
                    {tag.icon} {tag.name}
                  </Tag.CheckableTag>
                </Tooltip>
              ))}
            </div> */}
          </Col>

          {this.state.searching ? (
            <AdvancedSearchForm
              Columns={columns}
              lsStatus={this.state.lsStatus}
              paramsSearch={this.state.paramsSearch}
              callBackFilter={this.callBackFilter}
            />
          ) : null}
        </Row>

        <Table
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered={true}
          rowKey="id"
          scroll={{ x: 768 }}
          size="small"
          className="styleTable_1"
          onRow={(record) => ({
            onDoubleClick: () => {
              this.props.history.push(`/tickets/${record.id}`);
            },
          })}
          onChange={this.handleChange}
          pagination={{
            current: this.state.pagination.current,
            pageSize: this.state.pagination.pageSize,
            total: total_page,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "15", "25", "50"],
          }}
        />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    cloneTicket: (bool) => dispatch(cloneTicket(bool)),
    ticketData: (data) => dispatch(ticketData(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    userPermission: state.user.userPermission,
    ticketData: state.ticketData,
  };
};
// export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Danhsachyeucau));

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Danhsachyeucau)
);
